<template>
  <el-dialog
    title="添加派送方式"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form :model="form" :rules="rules" ref="form" label-width="120px">
      <el-form-item :label="$t('distributionMode.modeType')" prop="isShow">
        <el-select v-model="form.isShow" style="width:100%">
          <el-option
            disabled
            value=""
            :label="$t('distributionMode.selectMode')"
          ></el-option>
          <el-option
            value="100"
            :label="$t('distributionMode.fixedFee')"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('distributionMode.modeName')" prop="modeName">
        <el-input
          v-model="form.modeName"
          :placeholder="$t('distributionMode.modeNamePlaceholder')"
        ></el-input>
      </el-form-item>

      <el-form-item
        v-if="form.isShow == 100"
        :label="$t('distributionMode.fixedFee')"
        prop="fixedFee"
      >
        <el-input
          v-model="form.fixedFee"
          :placeholder="$t('distributionMode.fixedFeePlaceholder')"
        ></el-input>
      </el-form-item>

      <div v-if="form.isShow == 200">
        <el-form-item
          :label="$t('distributionMode.startDeliveryIn')"
          prop="startDeliveryIn"
        >
          <el-input
            v-model="form.startDeliveryIn"
            :placeholder="$t('distributionMode.startDeliveryInPlaceholder')"
          ></el-input>
        </el-form-item>

        <el-form-item
          :label="$t('distributionMode.startDeliveryOut')"
          prop="startDeliveryOut"
        >
          <el-input
            v-model="form.startDeliveryOut"
            :placeholder="$t('distributionMode.startDeliveryOutPlaceholder')"
          ></el-input>
        </el-form-item>

        <el-form-item
          :label="$t('distributionMode.maximumDistribution')"
          prop="maximumDistribution"
        >
          <el-input
            v-model="form.maximumDistribution"
            :placeholder="$t('distributionMode.maximumDistributionPlaceholder')"
          ></el-input>
        </el-form-item>
      </div>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { saveDistributionMode } from '@/api/goods/distributionModeApi'

export default {
  name: 'AddDistributionMode',
  data() {
    return {
      dialogVisible: false,
      form: {
        modeId: '',
        modeName: '',
        fixedFee: '',
        startDeliveryIn: '-1',
        startDeliveryOut: '-1',
        maximumDistribution: '-1',
        shopId: '',
        isShow: ''
      },
      rules: {
        modeName: [
          { required: true, message: this.$t('distributionMode.modeNameRequired'), trigger: 'blur' },
          { max: 30, message: this.$t('distributionMode.modeNameMaxLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return

        this.form.shopId = getShopId()

        try {
          await saveDistributionMode(this.form)
          this.$message.success(this.$t('distributionMode.addSuccess'))
          this.dialogVisible = false
          this.$emit('refresh')
        } catch (error) {
          console.error('添加派送方式失败:', error)
        }
      })
    }
  }
}
</script>